import {ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {NzFormDirective} from 'ng-zorro-antd/form';
import {GnFormConfig} from './FormConfig';
import {GnModalContent} from '../modal-button/ModalContent';
import {GnFormDirective} from '../form/form.directive';
import {GnMessageService} from '../message-service/message-service';
import {GnFormItemConfig} from './json-form-item/FormItemConfig';

@GnModalContent('json-form')
@Component({
  selector: 'gn-json-form',
  templateUrl: './json-form.component.html',
  styleUrls: ['./json-form.component.css']
})
export class GnJsonFormComponent {

  get url(): string {
    return this.urlValue;
  }

  @Input() set url(value: string) {
    this.urlValue = value;
    if (this.urlValue) {
      this.http.get(this.urlValue)
        .subscribe((resp: GnFormConfig) => {
            this.config = Object.assign(resp, this.defaultConfig);
            this.config.fields.sort(GnJsonFormComponent.sortField);
            this.changeDetectorRef.detectChanges();
            this.configLoaded.emit(this.config);
            this.form.loadData();
          },
          (err) => {
            this.messageService.error('获取表单配置错误');
            console.error(err);
          });
    }
  }

  constructor(private http: HttpClient,
              private messageService: GnMessageService,
              private changeDetectorRef: ChangeDetectorRef) {
  }

  private urlValue: string;

  @Input() config: GnFormConfig = {fields: []};
  @Input() dataId: string;
  @Input() defaultValue: any;
  @Input() defaultConfig: GnFormConfig;

  @Output() configLoaded = new EventEmitter<GnFormConfig>();

  @ViewChild(GnFormDirective, {static: true}) form: GnFormDirective;
  @ViewChild(NzFormDirective, {static: true}) nzForm: NzFormDirective;

  public static sortField(itemA: GnFormItemConfig, itemB: GnFormItemConfig): number {
    if ((itemA.showOrder || 0) > (itemB.showOrder || 0)) {
      return 1;
    } else if ((itemA.showOrder || 0) < (itemB.showOrder || 0)) {
      return -1;
    } else {
      return 0;
    }
  }

  public sortFields(): void {
    this.config.fields.sort(GnJsonFormComponent.sortField);
    this.changeDetectorRef.detectChanges();
  }
}
